import { createContext } from 'react';

import type { SankeyGraphModel } from '../types/sankey-internal.js';

export const SankeyDataContext = createContext<SankeyGraphModel>({
  nodes: [],
  links: [],
});

SankeyDataContext['displayName'] = 'SankeyDataContext';
